<template>
  <div class="box">
    <div class="content">
      <img
        v-if="tJhSaasChannelQuestionnaire.banner"
        class="content-bg"
        :src="tJhSaasChannelQuestionnaire.banner"
        alt
      />
      <div
        class="content-items"
        v-for="(item, index) in questionnaireTopicList"
        :key="item.id"
      >
        <!-- 标题 -->
        <p class="content-items-title">
          <span style="color: red">{{ item.isMustFill ? '*' : '' }}</span>
          {{ item.title }}
          <span
            class="content-items-remark"
            v-if="![2, 3, 4].includes(item.secondType)"
          >
            （{{ item.type | transType }}）
          </span>
        </p>
        <!-- 备注 -->
        <p class="content-items-remark" v-if="item.remark">
          备注：{{ item.remark }}
        </p>
        <!-- 单选、 投票 -->
        <ul
          class="content-items-common content-items-radio"
          v-if="item.type == 1 || item.type == 3"
        >
          <li
            :class="[
              item.value == item2 ? 'content-items-common-active' : '',
              'content-items-common-i'
            ]"
            v-for="(item2, index2) in item.optionJson"
            :key="index + index2"
            @click="radioHandle(item, item2)"
          >
            <img
              :src="
                require(item.value == item2
                  ? '@/assets/单选.png'
                  : '@/assets/单选题.png')
              "
              alt
            />
            <span>{{ item2 }}</span>
          </li>
          <p class="content-items-error">答案不能为空</p>
        </ul>
        <!-- 多选 -->
        <ul
          class="content-items-common content-items-radio"
          v-if="item.type == 2"
        >
          <li
            :class="[
              item.value && item.value.includes(item2)
                ? 'content-items-common-active'
                : '',
              'content-items-common-i'
            ]"
            v-for="(item2, index2) in item.optionJson"
            :key="index + index2"
            @click="checkHandle(item, item2)"
          >
            <img
              :src="
                require(item.value && item.value.includes(item2)
                  ? '@/assets/多选_已点击.png'
                  : '@/assets/多选题.png')
              "
              alt
            />
            <span>{{ item2 }}</span>
          </li>
          <p class="content-items-error">答案不能为空</p>
        </ul>
        <!-- 单填空 -->
        <div
          class="content-items-common content-items-radio"
          v-if="item.type == 4"
        >
          <input
            type="text"
            class="content-items-common-i"
            v-model="item.value"
          />
          <p class="content-items-error">答案不能为空</p>
        </div>
        <!-- 多填空 -->
        <ul
          class="content-items-common content-items-textmore"
          v-if="item.type == 5"
        >
          <li
            v-for="(item2, index2) in item.manyTitleJson"
            :key="index + index2"
          >
            <p>{{ item2 }}</p>
            <input
              type="text"
              class="content-items-common-i"
              v-model="item.value[index2]"
            />
          </li>
          <p class="content-items-error">答案不能为空</p>
        </ul>
        <!-- 评分 -->
        <div
          class="content-items-common content-items-rate"
          v-if="item.type == 6"
        >
          <van-rate v-model="item.value" />
          <p class="content-items-error">答案不能为空</p>
        </div>
        <!-- 文件类型 -->
        <div
          class="content-items-common content-items-upload"
          v-if="[8, 9, 10, 11, 12, 13].includes(+item.type)"
        >
          <van-uploader
            :max-size="50 * 1024 * 1024"
            :accept="judgeAcc(item)"
            v-model="item.value"
            :before-read="closureBeforRead(item)"
            :after-read="afterRead"
            :max-count="[8, 13].includes(+item.type) ? 10 : 1"
            result-type="file"
            upload-icon="https://cdn.yxvzb.com/WEB/XCX/img/0513add.png"
            :multiple="[8, 13].includes(+item.type)"
          />
          <p class="content-items-error">最少上传一个文件</p>
        </div>
        <!-- 时间题年月日时分 -->
        <div class="content-items-common" v-if="item.type == 14">
          <el-date-picker
            style="width: 367px"
            v-if="isDesktop"
            v-model="item.value"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="请选择时间"
          ></el-date-picker>
          <van-field
            class="timeBox"
            v-else
            v-model="item.value"
            placeholder="请选择时间"
            is-link
            @click="beginShowTime(item, index, 'datetime')"
            left-icon="clock-o"
            readonly
          />
        </div>
        <div class="content-items-common" v-if="item.type == 15">
          <el-date-picker
            style="width: 367px"
            v-if="isDesktop"
            v-model="item.value"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择月份"
          ></el-date-picker>
          <van-field
            class="timeBox"
            v-else
            v-model="item.value"
            placeholder="请选择月份"
            is-link
            @click="beginShowTime(item, index, 'year-month')"
            left-icon="https://cdn.yxvzb.com/WEB/SaaS/images/rili.png"
            readonly
          />
        </div>
        <div class="content-items-common" v-if="item.type == 16">
          <gps @finishMap="receiveMap" :countIndex="index"></gps>
        </div>
      </div>
    </div>
    <div class="flooter">
      <!-- <p>{{ flootText }}</p> -->
      <div @click="send">提 交</div>
    </div>
    <van-popup
      v-model="showTime"
      position="bottom"
      round
      :style="{ height: '50%' }"
    >
      <van-datetime-picker
        v-model="timeValue"
        :type="pickerType"
        title="选择完整时间"
        @cancel="showTime = false"
        @confirm="confirmTime"
        :min-date="minDate"
        :max-date="maxDate"
      />
      <p class="content-items-error">答案不能为空</p>
    </van-popup>
  </div>
</template>
<script>
import { Toast, Notify, Uploader } from 'vant';
import { transAllTime, transMonth } from '@/utils/tools';
import gps from './child/gps.vue';
import { mapState } from 'vuex';

import { questionnaire, fileUpload, image, index } from '@/api/ajax';
import { questionType } from '@/static/data';
import validator from '@/utils/validator';
// 与类型对应文件类型
const fileTypeMap = {
  8: {
    accept: 'image/*,.pdf',
    MIME: ['image', 'pdf']
  },
  9: {
    accept: '.pdf',
    MIME: ['pdf']
  },
  10: {
    accept: '.doc,.dot,.docx,.dotx',
    MIME: [
      'msword',
      'vnd.openxmlformats-officedocument.wordprocessingml.document',
      'vnd.openxmlformats-officedocument.wordprocessingml.template'
    ]
  },
  11: {
    accept: '.xlc,.xlm,.xls,.xlt,.xlw,.xlsx,.xltx,.xlsm,.xlsb',
    MIME: [
      'vnd.ms-excel',
      'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'vnd.openxmlformats-officedocument.spreadsheetml.template',
      'vnd.ms-excel.addin.macroEnabled.12',
      'vnd.ms-excel.sheet.binary.macroEnabled.12'
    ]
  },
  12: {
    accept: '.ppt,.pptx',
    MIME: [
      'vnd.ms-powerpoint',
      'vnd.openxmlformats-officedocument.presentationml.presentation'
    ]
  },
  13: { accept: '.png,.jpg,.jpeg', MIME: ['image'] }
};
// 题目类型   1 单选  2 多选  3 单项投票  4 单项填空 5 多项填空 6 打分题  7 地址
export default {
  props: {
    questionnaireId: Number
  },
  data() {
    return {
      minDate: new Date(1980, 0, 1),
      maxDate: new Date(2025, 10, 1),
      flootText: '向日葵平台提供问卷技术支持',
      sendData: null,
      tJhSaasChannelQuestionnaire: {},
      questionnaireTopicList: null,
      errorIndex: -1,
      shareTimes: 0,
      showTime: false,
      timeValue: new Date(),
      timeIndex: '',
      pickerType: 'datetime',
      noAccept: false
    };
  },
  computed: {
    ...mapState({
      isDesktop: state => state.living.isDesktop
    })
  },
  components: {
    gps
  },
  methods: {
    judgeAcc(item) {
      if (this.noAccept) {
        return '';
      } else {
        return item.fileType;
      }
    },
    receiveMap(mapInfo) {
      //接收地图组件传参
      let src = `https://apis.map.qq.com/ws/staticmap/v2/?center=${mapInfo.latitude},${mapInfo.longitude}&zoom=18&size=685*316&maptype=roadmap&markers=size:large|icon:https://lbs.qq.com|color:0xFFCCFF|label:k|${mapInfo.latitude},${mapInfo.longitude}&key=ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU`;
      this.questionnaireTopicList[mapInfo.count].value = {
        ...mapInfo
      };
    },
    beginShowTime(item, index, type) {
      this.pickerType = type;
      this.timeIndex = index;
      if (item.value && this.pickerType == 'datetime') {
        let val = item.value
          .replace(/年|月/g, '/')
          .replace('日', ' ')
          .replace('时', ':')
          .replace('分', '');
        this.timeValue = new Date(val);
      } else if (item.value && this.pickerType == 'year-month') {
        let val = item.value.replace('年', '/').replace('月', '');
        val += '/01';
        this.timeValue = new Date(val);
        // alert(this.timeValue)
      }
      this.showTime = true;
    },
    confirmTime() {
      //确认时间 关闭遮罩
      let time;
      if (this.pickerType == 'datetime') {
        time = transAllTime(new Date(this.timeValue).getTime());
      } else {
        time = transMonth(new Date(this.timeValue).getTime());
      }
      this.questionnaireTopicList[this.timeIndex].value = time;
      this.showTime = false;
      this.timeValue = new Date();
    },
    async uploadFile(nfile, file) {
      //上传文件
      let fd = new FormData();
      let fileType = file.name.split('.').slice(-1)[0];
      fd.append('file', nfile || file.file);
      try {
        let {
          data: {
            data: { fileUrl }
          }
        } = await fileUpload(fd);
        file.url = fileUrl;
        file.content = fileUrl;
        file.status = 'done';
        file.message = '上传完成';
        file.fileType = fileType || 'image/png';
      } catch (e) {
        Toast('上传失败');
        file.status = 'failed';
        file.message = '上传失败';
      }
    },
    async afterRead(file) {
      //文件读取完成的回调
      if (file && file.length > 1) {
        //多选
        for (let i = 0; i < file.length; i++) {
          let files = file[i];
          files.status = 'uploading';
          files.message = '上传中...';
          files.name = files.file.name;
          if (/pdf/.test(files.file.type)) {
            files.isPdf = true;
          }
          let fd = new FormData();
          let nfile;
          let fileType = file.name.split('.').slice(-1)[0];
          // console.log(fileType, 123123);
          // 部分手机（华为）选择部分图片不带类型，暂时简单处理
          if (!fileType) {
            nfile = new File([files.file], 'xxx.png', { type: 'image/png' });
          }
          this.uploadFile(nfile, files);
        }
      } else {
        file.status = 'uploading';
        file.message = '上传中...';
        file.name = file.file.name;
        if (/pdf/.test(file.file.type)) {
          file.isPdf = true;
        }
        let fd = new FormData();
        let nfile;
        let fileType = file.name.split('.').slice(-1)[0];
        // 部分手机（华为）选择部分图片不带类型，暂时简单处理
        if (!fileType) {
          nfile = new File([file.file], 'xxx.png', { type: 'image/png' });
        }
        this.uploadFile(nfile, file);
      }
    },
    closureBeforRead(item) {
      //文件读取前的回调
      return file => {
        if (Array.isArray(file)) {
          if (file.length > 10) {
            Toa1st('图片上传不得超过10张');
            return false;
          }
          //多选上传
          if (this.$route.query.flag) {
            Toast('预览模式不可操作');
            return false;
          }
          let returnFlag = true;
          file.filter(items => {
            // let { type } = items;
            let type = file.name.split('.').slice(-1)[0];
            let mimes = fileTypeMap[item.type].accept;
            if (items.size > 50 * 1024 * 1024) {
              returnFlag = false;
            }
            if (type) {
              let next = false;
              mimes.indexOf(type) > -1 ? (next = true) : '';
              // mimes.forEach(t => {
              //   if (type.includes(t)) {
              //     next = true;
              //   }
              // });
              if (!next) {
                Toast('请上传对应类型文件');
                returnFlag = false;
              }
            }
          });
          return returnFlag;
        } else {
          //单个上传
          let type = file.name.split('.').slice(-1)[0];
          let mimes = fileTypeMap[item.type].accept;
          if (this.$route.query.previewFlag) {
            Toast('预览模式不可操作');
            return false;
          }
          if (file.size > 50 * 1024 * 1024) {
            return false;
          }
          // 简单处理不带后缀的文件
          if (!type) {
            return true;
          } else {
            let next = false;
            mimes.indexOf(type) > -1 ? (next = true) : '';
            // mimes.forEach(t => {
            //   if (type.includes(t)) {
            //     next = true;
            //   }
            // });
            if (!next) {
              Toast('请上传对应类型文件');
              return false;
            }
          }
          return true;
        }
      };
    },
    // 返回布尔值
    beforeRead(file, detail) {
      // console.log(detail);
    },
    /**
     * @description: 单选\投票 选择,修改添加父级value字段
     * @param {array,string}
     * @return: void
     */
    radioHandle(parentItem, childItem) {
      this.$set(parentItem, 'value', childItem);
    },
    /**
     * @description: 多选 选择,修改添加父级value字段
     * @param {array,string}
     * @return: void
     */
    checkHandle(parentItem, childItem) {
      if (parentItem.value) {
        let index = parentItem.value.indexOf(childItem);
        // 存在则删除
        if (index !== -1) {
          parentItem.value.splice(index, 1);
          return false;
        }
        parentItem.value.push(childItem);
      } else {
        this.$set(parentItem, 'value', [childItem]);
      }
    },
    // 提交
    async send() {
      // 预览不可提交
      if (this.$route.query.flag) {
        Toast.fail('预览不可以提交');
        return false;
      }
      console.log(this.sendData);
      let answers = [];
      let answerEndDt = Date.now();
      let canSend = true;
      let errorMsg = '请填写完整内容';
      let secondTypeValidator = {
        2: {
          func: 'isMobile',
          error: '请填写正确手机号'
        },
        3: {
          func: 'isEmail',
          error: '请填写正确邮箱'
        },
        4: {
          func: 'isRealName',
          error: '请填写正确姓名'
        }
      };
      answers = this.questionnaireTopicList.map(item => {
        // 判断是否全部填充
        if (
          item.isMustFill &&
          (item.value === '' ||
            item.value === null ||
            (item.value instanceof Array &&
              (item.value.includes('') || !item.value.length)))
        ) {
          canSend = false;
          return false;
        }
        //  2手机 3邮箱 4姓名
        if (item.type === 4 && [2, 3, 4].includes(item.secondType)) {
          let validateObj = secondTypeValidator[item.secondType];
          let validatRes = validator[validateObj.func](item.value);
          if (!validatRes) {
            errorMsg = validateObj.error;
            canSend = false;
            return false;
          }
        }
        if ([8, 9, 10, 11, 12, 13].includes(+item.type)) {
          let f = true;
          let fileValues = [];
          let minCount = +item.optionJson[0] || 1;
          item.value.forEach(i => {
            if (i.status === 'failed') {
              f = false;
              errorMsg = `【${item.title}】该题上传失败，请检查`;
            }
            i.url && fileValues.push(i.url);
          });
          // 必填的，上传文件必须大等最少限制。不必填的如果上传了也必须大等最少限制
          if (
            (item.isMustFill && fileValues.length < minCount) ||
            (!item.isMustFill &&
              fileValues.length &&
              fileValues.length < minCount)
          ) {
            f = false;
            errorMsg = `【${item.title}】该题至少上传${minCount}个文件`;
          }
          if (!f) {
            canSend = false;

            return false;
          }
        }
        // 如果是obj 转成 JSON
        let im = {
          topicId: item.id,
          answer:
            typeof item.value == 'object'
              ? JSON.stringify(item.value)
              : item.value + ''
        };

        return im;
      });
      if (this.isDesktop && !canSend) {
        this.$toast(errorMsg);
        return false;
      } else if (!canSend) {
        Notify({
          message: errorMsg,
          type: 'warning',
          duration: 3 * 1000
        });
        return false;
      }
      let text = '提交中...';
      Toast.loading({
        mask: true,
        forbidClick: true,
        message: text
      });
      try {
        // code 1 已提交 2 成功
        let { code } = await questionnaire.answerQuestionnaire({
          ...this.sendData,
          answerEndDt,
          answers
        });
        this.$toast('提交成功');
        Toast.clear();
        if (this.questionnaireId) {
          return;
        }
        this.$router.push({ name: 'surveyFinish', query: { code: 2 } });
      } catch (e) {
        console.log(e);
        if (e.data === '-1') {
          this.$dialog.alert({
            message: '当前问卷题目有调整，请重新填写。',
            beforeClose: (action, done) => {
              done();
              window.location.reload();
            }
          });
        }
      }
    },
    back() {
      this.$nativeMethod.goBack();
    }
  },
  watch: {
    // $route: {
    //   immediate: true,
    //   handler (v) {
    //     // 监听小程序分享后修改 shareTimes 参数，以识别已分享了
    //     let { shareTimes = 0 } = v.query;
    //     // 因为小程序分享后返回 会返回webview上次的url，此处对比shareTimes，主动触发后退
    //     if (this.shareTimes > shareTimes) {
    //       this.$nativeMethod.goBack();
    //       return false;
    //     }
    //     this.shareTimes = shareTimes;
    //     if (shareTimes) {
    //       window.shareSuccess();
    //     }
    //   }
    // }
  },
  filters: {
    transType(v) {
      return questionType[v - 1].label;
    }
  },
  async created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger' && isAndroid) {
      this.noAccept = true;
    }
    // 分享回调
    window.shareSuccess = () => {
      // this.flootText = "分享成功";
      this.$sa.re_interaction({
        type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
        contentype: '调研', // 互动主体 直播，录播，资讯，病例，站内信，论坛, 调研
        contentid: this.tJhSaasChannelQuestionnaire.id, // 内容id
        contentname: this.tJhSaasChannelQuestionnaire.title
        //  source_user_id: this.$route.query.source_user_id || "", // 邀请人ID 全局使用
        //  projectId: this.$route.query.projectId || ""
      });
    };
    // 预览时传入数据
    window.emitPreview = data => {
      // console.log(data)
      const { questionnaireTopicList, tSaasQuestionnaire } = data;
      this.tJhSaasChannelQuestionnaire = tSaasQuestionnaire;
      // console.log(this.tJhSaasChannelQuestionnaire)
      this.questionnaireTopicList = questionnaireTopicList.map(item => {
        if (!item.value) {
          if (+item.type === 5) {
            item.value = new Array(item.manyTitleJson.length).fill('');
          } else if ([8, 9, 10, 11, 12, 13].includes(+item.type)) {
            item.value = [];
            item.fileType = fileTypeMap[item.type].accept;
          } else {
            item.value = '';
          }
        }
        return item;
      });
    };

    // previewFlag 预览 1 注入数据 2 通过ID获取数据
    // if (+previewFlag === 1) {
    //   return false;
    // }
    // 必须有项目ID 与 类型
    // if (!projectId || !projectType) {
    //   Notify({
    //     message: '页面参数错误！',
    //     type: 'warning',
    //     duration: 0
    //   });
    //   return false;
    // }
    // questionnaireId 为问卷ID，用于直播
    let { id } = this.$route.params;
    if (this.questionnaireId) {
      id = this.questionnaireId;
    }
    if (this.$route.query.flag !== 'preview') {
      let {
        data: {
          data: { tJhSaasChannelQuestionnaire, questionnaireTopicList }
        }
      } = await questionnaire.questionnaireData({
        id
      });
      // 提交参数
      let sendData = {
        answerStartDt: Date.now(),
        questionnaireId: tJhSaasChannelQuestionnaire.id,
        answerEndDt: '',
        answers: []
      };
      // 需要提交的数据
      this.sendData = sendData;
      this.tJhSaasChannelQuestionnaire = tJhSaasChannelQuestionnaire;
      this.questionnaireTopicList = questionnaireTopicList.map(item => {
        if (!item.value) {
          // 如果是多选则建立绑定数组
          if (+item.type === 5) {
            // 填空题 对应 value
            item.value = new Array(item.manyTitleJson.length).fill('');
          } else if ([8, 9, 10, 11, 12, 13].includes(+item.type)) {
            item.value = [];
            item.fileType = fileTypeMap[item.type].accept;
          } else {
            item.value = '';
          }
        }
        return item;
      });
      try {
        const {
          data: {
            data: { bgUrl }
          }
        } = await index.channelData();
        // this.$wxShare({
        //   title: this.tJhSaasChannelQuestionnaire.title,
        //   target: window.location.href,
        //   imgUrl: bgUrl,
        //   desc: this.tJhSaasChannelQuestionnaire.title
        // });
      } catch (e) {
        console.log(e);
      }
    }

    // 初始化容器信息
    // this.$nativeMethod.postMessage({
    //   showTitle: true,
    //   showBack: true,
    //   pageTitle: tJhSaasChannelQuestionnaire.title, // 页面标题
    //   title: tJhSaasChannelQuestionnaire.title, // 分享标题
    //   description: tJhSaasChannelQuestionnaire.title, // 描述
    //   show: true, // 是否显示右上角
    //   webpageUrl: `${this.$Config.baseUrl}/html/index.html#/survey`, // web URL location.protocol+'//'+document.domain + '/#/survey'
    //   path: '/pages/sDetail/main', // 小程序 地址
    //   query: `?projectId=${projectId}&projectType=${projectType}&source_user_id=${source_user_id ||
    //     userId}&fromcode=${fromcode}`, // 参数  projectId, projectType, userId, source_user_id
    //   xcxShareImg: '', // 小程序分享图片
    //   img:
    //     'http://cdn.yxvzb.com/WEB/SaaS/webview/images/%E8%B0%83%E7%A0%94%E5%88%86%E4%BA%AB.png', // 分享图片
    //   userName: 'gh_931716f1ebfc', // 小程序 userName
    //   type: this.$Config.xcxType //分享小程序的版本（0-正式，1-开发，2-体验）
    // });
    // wx.miniProgram.navigateTo({url: '/pages/first/main'})
    // wx.miniProgram.postMessage({ data: '1111' })
  }
};
</script>
<style lang="less">
.van-rate__icon {
  font-size: 0.63rem !important;
}
.van-rate__item {
  margin-right: 0.4rem;
}
.box {
  .content {
    .van-icon {
      line-height: initial;
    }
  }
}
.van-field__control {
  font-size: 16px;
}
</style>

<style lang="less" scoped>
@media (max-width: 600px) {
  .box {
    text-align: left;
    .content {
      padding: 0 27px;
      background: #fff;
      &-bg {
        width: 100%;
        height: 6.03rem;
        margin-bottom: 0.56rem;
        display: block;
      }
      &-items {
        &-title {
          font-size: 0.43rem;
          font-weight: 500;
          margin-bottom: 0.32rem;
        }
        &-remark {
          color: #c3c3c3;
          font-size: 0.32rem;
          margin-bottom: 0.21rem;
        }
        &-error {
          display: none;
        }
        &-common {
          margin-bottom: 0.75rem;
          .timeBox {
            width: 9.15rem;
            height: 1.28rem;
            border-radius: 0.16rem;
            border: 1px solid rgba(234, 234, 236, 1);
            font-size: 0.43rem;
            align-items: center;
          }
          &-i {
            width: 100%;
            font-size: 0.35rem;
            font-weight: 400;
            height: 1.13rem;
            border-radius: 1.5px;
            border: 1px solid rgba(220, 238, 255, 1);
            margin-bottom: 0.45rem;
            padding: 0.33rem 0.37rem;
            display: flex;
            align-items: center;
            img {
              width: 0.45rem;
              height: 0.45rem;
              margin-right: 0.33rem;
            }
          }
          &-i:last-child {
            margin-bottom: 0;
          }
          &-active {
            background: rgba(220, 238, 255, 1);
            border: 1px solid rgba(25, 137, 250, 1);
          }
        }
        &-radio {
        }
        &-textmore {
          p {
            padding-left: 0.4rem;
            margin-bottom: 0.21rem;
          }
          li {
            margin-bottom: 0.28rem;
          }
          li:last-child {
            margin-bottom: 0;
          }
        }
        &-rate {
          padding-left: 0.4rem;
        }
      }
    }
    .flooter {
      width: 100%;
      background: #e5e5e5;
      padding: 0.67rem 1.13rem 0.4rem;
      text-align: center;
      font-size: 0.4rem;
      color: #666;
      p {
        margin-bottom: 0.37rem;
      }
      div {
        width: 100%;
        height: 1.17rem;
        background: rgba(90, 156, 248, 1);
        border-radius: 0.11rem;
        line-height: 1.17rem;
        color: #fff;
      }
    }
  }
}
@media (min-width: 600px) {
  .box {
    text-align: left;
    .content {
      padding: 0.27rem 0.4rem;
      background: #fff;
      &-bg {
        width: 100%;
        height: 6.03rem;
        margin-bottom: 0.56rem;
        display: block;
      }
      &-items {
        &-title {
          font-size: 16px;
          font-weight: 400;
          margin-bottom: 16px;
        }
        &-remark {
          font-size: 16px;
          font-weight: 400;
          color: #9394a0;
          margin-bottom: 16px;
        }
        &-error {
          display: none;
        }
        &-common {
          margin-bottom: 16px;
          .timeBox {
            width: 367px;
            height: 40px;
            border: 1px solid #dedede;
            font-size: 16px;
            align-items: center;
          }
          &-i {
            width: 367px;
            height: 40px;
            border: 1px solid #dedede;
            font-size: 16px;
            border-radius: 1.5px;
            border: 1px solid rgba(220, 238, 255, 1);
            margin-bottom: 0.45rem;
            padding: 15px 6px;
            display: flex;
            align-items: center;
            img {
              width: 16px;
              height: 16px;
              margin-right: 0.33rem;
            }
          }
          &-i:last-child {
            margin-bottom: 0;
          }
          &-active {
            background: rgba(220, 238, 255, 1);
            border: 1px solid rgba(25, 137, 250, 1);
          }
        }
        &-radio {
        }
        &-textmore {
          p {
            margin-bottom: 8px;
          }
          li {
            margin-bottom: 8px;
          }
          li:last-child {
            margin-bottom: 0;
          }
        }
        &-rate {
          padding-left: 0.4rem;
        }
      }
    }
    .flooter {
      width: 368px;
      text-align: center;
      font-size: 14px;
      color: #666;
      margin-left: 20px;
      div {
        width: 100%;
        height: 36px;
        background: #027cfa;
        border-radius: 6px;
        line-height: 36px;
        color: #fff;
      }
    }
  }
}
</style>
